import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import InventoryNav from "../../components/InventoryNav";
import "./Inventory.css";
import API_BASE_URL from "../../apiConfig";
import IMG_HOST from "../../apiConfigImgs";

const Inventory = () => {
  const [fullItems, setFullItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All Items");
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchInventory = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/inventory`, {
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (isMounted) {
          setFullItems(data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching inventory:", error);
        if (isMounted) {
          setFetchError(error.message);
          setLoading(false);
        }
      }
    };

    fetchInventory();
    return () => {
      isMounted = false;
    };
  }, []);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const displayedItems = fullItems.filter((item) => {
    const matchesSearch =
      searchQuery.trim() === "" ||
      item.itemName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.sku.toLowerCase().includes(searchQuery.toLowerCase());

    return selectedCategory === "All Items"
      ? matchesSearch
      : item.location === selectedCategory && matchesSearch;
  });

  const getImageUrl = (imgUrl) => {
    if (!imgUrl) {
      return `${process.env.PUBLIC_URL}/static/imgs/fallback-image.png`;
    }
    return imgUrl.startsWith('/uploads/')
      ? `${IMG_HOST}${imgUrl.replace('/uploads/', '')}`
      : imgUrl.startsWith('http')
      ? imgUrl
      : `${IMG_HOST}${imgUrl}`;
  };

  return (
    <div className="inventory-page">
      <div className="container">
        <header className="inventory-header">
          <h1>Capstone Inventory</h1>
        </header>

        <InventoryNav
          selectedCategory={selectedCategory}
          onCategorySelect={handleCategorySelect}
        />

        <section className="search-section">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search by name or SKU..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="scan-btn">
              <i className="fas fa-qrcode"></i> Scan
            </button>
            <Link to="/add-product" className="add-btn">
              <i className="fas fa-plus"></i> Add Item
            </Link>
          </div>
        </section>

        <section className="inventory-items">
          {loading ? (
            <p className="loading-text">Loading inventory...</p>
          ) : fetchError ? (
            <p className="error-text">Error: {fetchError}</p>
          ) : displayedItems.length > 0 ? (
            <div className="inventory-grid">
              {displayedItems.map((item) => (
                <div className="inventory-card" key={item._id || item.sku}>
                  <h2>{item.itemName}</h2>
                  <p>SKU: {item.sku}</p>
                  <p>Qty: {item.quantity}</p>
                  <div className="inventory-images">
                    {item.images && item.images.length > 0 ? (
                      item.images.map((img, idx) => (
                        <img
                          key={idx}
                          src={getImageUrl(img.url)}
                          alt={img.description || item.itemName}
                          className="inventory-img"
                          onError={(e) => {
                            e.target.src = `${process.env.PUBLIC_URL}/static/imgs/fallback-image.png`;
                          }}
                        />
                      ))
                    ) : (
                      <p className="no-images">No Images</p>
                    )}
                  </div>
                  <Link to={`/inventory/${item.sku}`} className="details-btn">
                    View Details
                  </Link>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-items">No items found.</p>
          )}
        </section>
      </div>
    </div>
  );
};

export default Inventory;